// Aktualizacja kontekstu wątku czatu

import { orionAxios } from '../orionApi';
import { UpdateThreadContextRequest } from './orionTypes';

/**
 * Aktualizuje kontekst wątku (np. przy zmianie strony)
 * @param threadId - UUID wątku
 * @param data - nowy kontekst wątku
 */
export const updateThreadContext = async (
  threadId: string,
  data: UpdateThreadContextRequest
): Promise<void> => {
  await orionAxios.post(`/api/aiassistant/update-thread-context/${threadId}`, data);
};

